module.exports = __webpack_public_path__ + "static/media/ourvision.b2eeb169.svg";